import TicketFareIcon from '@/components/tenants/dpmp/icons/TicketFareIcon.vue';
import CardManagingAccountIcon from '@/components/tenants/dpmp/icons/CardManagingAccountIcon.vue';
import ElectronicWalletIcon from '@/components/tenants/dpmp/icons/ElectronicWalletIcon.vue';
import ShoppingCartTopIcon from '@/components/tenants/dpmp/icons/ShoppingCartTopIcon.vue';
import UserAccountIcon from '@/components/tenants/dpmp/icons/UserAccountIcon.vue';
import OrderListIcon from '@/components/tenants/dpmp/icons/OrderListIcon.vue';
import ChipCardIcon from '@/components/tenants/dpmp/icons/ChipCardIcon.vue';
import AssignedCardListIcon from '@/components/tenants/dpmp/icons/AssignedCardListIcon.vue';
import ManagedCardListIcon from '@/components/tenants/dpmp/icons/ManagedCardListIcon.vue';
import CardApplicationListIcon from '@/components/tenants/dpmp/icons/CardApplicationListIcon.vue';
import PakTransferIcon from '@/components/tenants/dpmp/icons/PakTransferIcon.vue';
import NewCardApplicationIcon from '@/components/tenants/dpmp/icons/NewCardApplicationIcon.vue';
import AssignCardIcon from '@/components/tenants/dpmp/icons/AssignCardIcon.vue';
import PayByCardIcon from '@/components/tenants/dpmp/icons/PayByCardIcon.vue';
import PayByInvoiceIcon from '@/components/tenants/dpmp/icons/PayByInvoiceIcon.vue';
import CancelAllIcon from '@/components/tenants/dpmp/icons/CancelAllIcon.vue';
import ManageCardRequestIcon from '@/components/tenants/dpmp/icons/ManageCardRequestIcon.vue';
import LogoutIcon from '@/components/tenants/dpmp/icons/LogoutIcon.vue';
import LoginIcon from '@/components/tenants/dpmp/icons/LoginIcon.vue';
import RegistrationSendIcon from '@/components/tenants/dpmp/icons/RegistrationSendIcon.vue';
import NotificationSettingIcon from '@/components/tenants/dpmp/icons/NotificationSettingIcon.vue';

export const dpmpIcons = {
  account: UserAccountIcon,
  assignCardIcon: AssignCardIcon,
  assignedCardListIcon: AssignedCardListIcon,
  bankCardApplicationIcon: NewCardApplicationIcon,
  cancelAllIcon: CancelAllIcon,
  cardApplicationListIcon: CardApplicationListIcon,
  cardManagingAccountIcon: CardManagingAccountIcon,
  chipCardIcon: ChipCardIcon,
  electronicWalletIcon: ElectronicWalletIcon,
  externalCardApplicationIcon: NewCardApplicationIcon,
  forgottenPasswordIcon: RegistrationSendIcon,
  loginIcon: LoginIcon,
  logoutIcon: LogoutIcon,
  manageCardRequestIcon: ManageCardRequestIcon,
  managedCardListIcon: ManagedCardListIcon,
  newCardApplicationIcon: NewCardApplicationIcon,
  notificationSettingIcon: NotificationSettingIcon,
  orderListIcon: OrderListIcon,
  pakTransferIcon: PakTransferIcon,
  payByCardIcon: PayByCardIcon,
  payByInvoiceIcon: PayByInvoiceIcon,
  reclamationIcon: NewCardApplicationIcon,
  registrationSendIcon: RegistrationSendIcon,
  shoppingCartIcon: ShoppingCartTopIcon,
  shoppingCartTopIcon: ShoppingCartTopIcon,
  ticketFareIcon: TicketFareIcon,
  verificationCodeIcon: RegistrationSendIcon,
};
